//@ts-expect-error untyped
import { NPS, CSAT } from 'feedback-schema/constants/surveyTypes';
export const SurveyTypeEnum = {
  [NPS]: 1,
  [CSAT]: 3
};